import { Rating } from "react-simple-star-rating";
import { Button, Col, Media, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { Href } from "../../../../constants";
import { WishlistProduct } from "../../../../data/applications/ECommerce";
import { dynamicImage } from "../../../../utils";
import { Image } from "../../../../coreComponents/Image";

// This component displays a list of products added to the user's wishlist.
const WishlistProducts = () => {

  return (
    <Row className="g-sm-4 g-3">
      {WishlistProduct.map((item, index) => (
        <Col xxl="4" md="6" key={index}>
          <div className="prooduct-details-box">
            <Media className="d-flex">
              <Image className="align-self-center img-fluid img-60" src={dynamicImage(`ecommerce/${item.image}`)} alt="#" />
              <Media body className="ms-3 flex-grow-1">
                <div className="product-name">
                  <h6>
                    <Link to={Href}>{item.name}</Link>
                  </h6>
                </div>
                <Rating initialValue={5} size={17} />
                <div className="price d-flex border-0 p-0">
                  <div className="text-muted me-2">Price</div> : 210$
                </div>
                <div>
                  <div className="text-success">In stock</div>
                </div>
                <div>
                  <Button tag="a" href={Href} color="primary" size="xs">{`MoveToCarts`}</Button>
                </div>
              </Media>
            </Media>
          </div>
        </Col>
      ))}
    </Row>
  );
};
export default WishlistProducts;